<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="goodsId" :label="$t('商品ID')">

        <a-input v-model="form.goodsId"  :placeholder="$t('请输入')+$t('商品ID')" />
      </a-form-model-item>
      <a-form-model-item prop="goodsName" :label="$t('商品名称')">

        <a-input v-model="form.goodsName" :maxLength="255" :placeholder="$t('请输入')+$t('商品ID')" />
      </a-form-model-item>
      <a-form-model-item prop="mainImage" :label="$t('商品主图URL')">
        <file-upload v-model="form.mainImage" type="image"></file-upload>
      </a-form-model-item>
      <a-form-model-item prop="module" :label="$t('所属板块')">
      </a-form-model-item>
      <a-form-model-item prop="searchCount" :label="$t('搜索次数')">
        <a-input v-model="form.searchCount"  :placeholder="$t('请输入')+$t('搜索次数')" />
      </a-form-model-item>
      <a-form-model-item prop="sort" :label="$t('排序')">
        <a-input v-model="form.sort"  :placeholder="$t('请输入')+$t('排序')" />
      </a-form-model-item>
      <a-form-model-item prop="status" :label="$t('状态')">
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getSearchHotGood, addSearchHotGood, updateSearchHotGood } from '@/api/search/searchHotGood'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,

        goodsId: null,

        goodsName: null,

        mainImage: null,

        module: null,

        searchCount: null,

        sort: null,

        status: null,

        createTime: null,
        localeFieldMap:{},

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        goodsId: [
          { required: true, message: this.$t('商品ID')+this.$t('不能为空'), trigger: 'blur' }
        ],
        goodsName: [
          { required: true, message: this.$t('商品名称')+this.$t('不能为空'), trigger: 'blur' }
        ],
        mainImage: [
          { required: true, message: this.$t('商品主图URL')+this.$t('不能为空'), trigger: 'blur' }
        ],
        module: [
          { required: true, message: this.$t('所属板块')+this.$t('不能为空'), trigger: 'change' }
        ],
        searchCount: [
          { required: true, message: this.$t('搜索次数')+this.$t('不能为空'), trigger: 'blur' }
        ],
        sort: [
          { required: true, message: this.$t('排序')+this.$t('不能为空'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('状态 1=启用 0=禁用')+this.$t('不能为空'), trigger: 'change' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        goodsId: null,
        goodsName: null,
        mainImage: null,
        module: null,
        searchCount: null,
        sort: null,
        status: null,
        createTime: null,
        localeFieldMap:{},
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getSearchHotGood({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateSearchHotGood(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addSearchHotGood(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
